var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 192.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3d3d3d;}.cls-2{fill:#5a0fc8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pwa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M376.82,158.24l14.79-37.4h42.71L414.05,64.1,439.4,0,512,192.77H458.46l-12.41-34.53Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.14,192.77,408.86,0H357.34L304.17,124.57,266.36,0H226.75L186.16,124.57,157.53,67.81l-25.91,79.81,26.31,45.15h50.71L245.32,81.06l35,111.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.91,126.59H80.65a93.79,93.79,0,0,0,25.68-3.21l8.21-25.29,22.94-70.68a55.61,55.61,0,0,0-6-7.85Q113.84,0,79.8,0H0V192.77H48.91Zm42-82.24q6.9,6.94,6.9,18.59T91.75,81.55q-6.65,7.64-24.5,7.64H48.91V37.4H67.39Q84,37.4,90.92,44.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwaLogo);
export default __webpack_public_path__ + "static/media/pwa_logo.4bc40c07cd9797b1cc379c27ef9fb7a8.svg";
export { ForwardRef as ReactComponent };